import { createFileRoute } from '@tanstack/react-router';
import { ReceivingView } from '../../receiving/receiving-view.js';

export const Route = createFileRoute('/_station/receiving')({
  component: ReceivingView,
});
